<template>
  <MobileHeaderComponent />
  <!-- Header -->
  <div class="coderpix_tm_header">
    <div class="header_inner">
      <div class="logo">
        <LogoComponent />
      </div>
      <div class="menu">
        <Menu />
      </div>
    </div>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";
import Menu from "./Menu.vue";
import MobileHeaderComponent from "./MobileHeaderComponent.vue";
import LogoComponent from "../LogoComponent.vue";

export default {
  name: `HeaderComponent`,
  components: { MobileHeaderComponent, Menu, LogoComponent },
  data() {
    return {
      navFuntions,
    };
  },
};
</script>

<style scoped>
.coderpix_tm_header {
  z-index: 100 !important; /* Menü her zaman en üstte olsun */
  pointer-events: none; /* Header konteyneri boşluğu engellemesin */
}
.header_inner {
  pointer-events: auto; /* İçerik (logo ve menü) tıklanabilir olsun */
}
</style>



